import {Component, Input, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "dynamic-field",
    templateUrl: "dynamic-field.component.html"
})

export class DynamicFieldComponent {
    @Input() field: any;
    @Input() form: FormGroup;

    readonly UKcities = [
        {city: "Tirane", cityCode: "UKT"},
        {city: "Divjake", cityCode: "UKDI"},
        {city: "Lushnje", cityCode: "UKLU"},
        {city: "Himare", cityCode: "UKHI"},
        {city: "Kukes", cityCode: "UKKU"},
        {city: "Mat", cityCode: "UKMA"},
        {city: "Roskovec", cityCode: "UKRV"},
        {city: "Kruje", cityCode: "UKKR"},
        {city: "Devoll", cityCode: "UKDV"},
        {city: "Kavaje", cityCode: "UKKV"},
        {city: "Shkoder", cityCode: "UKSH"},
        {city: "Elbasan", cityCode: "UKEL"},
        {city: "Pogradec", cityCode: "UKPG"},
        {city: "Fier", cityCode: "UKFR"},
        {city: "Korce", cityCode: "UKKO"},
        {city: "Shijak", cityCode: "UKSHI"},
        {city: "Vlore", cityCode: "UKVLORE"},
        {city: "Durres", cityCode: "UKD"}
    ];

    get isValid() {
        return this.form.controls[this.field.searchLabel].valid;
    }
}
